import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useToast } from '../../../shared/components/Toast/ToastContext';

/** Shows the original prompt this project was generated from, with a one-click copy. */
export function ProjectPromptDialog({
  open,
  projectName,
  prompt,
  onClose,
}: {
  open: boolean;
  projectName: string;
  prompt: string | null;
  onClose: () => void;
}) {
  const showToast = useToast();

  const handleCopy = async () => {
    if (!prompt) return;
    try {
      await navigator.clipboard.writeText(prompt);
      showToast({ title: 'Copied prompt to clipboard' });
    } catch {
      showToast({ title: 'Failed to copy to clipboard', severity: 'error' });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        Original prompt — {projectName}
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {prompt ? (
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
            {prompt}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No prompt was recorded for this project.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
        <Button variant="contained" startIcon={<ContentCopyIcon />} onClick={handleCopy} disabled={!prompt}>
          Copy to Clipboard
        </Button>
      </DialogActions>
    </Dialog>
  );
}
